// VOLTIX i18n dictionary. Keys are dot-notation.
// Falls back to PT if a key is missing in a language.
export const LOCALES = [
  { code: "pt", name: "Português", flag: "🇵🇹", dir: "ltr" },
  { code: "en", name: "English", flag: "🇬🇧", dir: "ltr" },
  { code: "fr", name: "Français", flag: "🇫🇷", dir: "ltr" },
  { code: "ar", name: "العربية", flag: "🇸🇦", dir: "rtl" },
];

const dict = {
  pt: {
    "nav.home": "Início", "nav.products": "Produtos", "nav.categories": "Categorias",
    "nav.new": "Novidades", "nav.promo": "Promoções", "nav.about": "Sobre nós",
    "nav.contact": "Contacto", "nav.wishlist": "Favoritos",
    "top.delivery": "Entrega em Portugal e Angola",
    "top.secure": "Pagamentos seguros com Stripe",
    "status.pending": "Aguarda pagamento", "status.unpaid": "Por pagar",
    "status.paid_partial": "1.ª parcela paga", "status.paid": "Pago",
    "status.processing": "Em preparação", "status.shipped": "Expedida",
    "status.delivery_pending": "Em entrega", "status.delivered": "Entregue",
    "status.cancelled": "Cancelada", "status.refunded": "Reembolsada",
    "top.markets": "🇵🇹 Portugal · 🇦🇴 Angola",
    "cta.login": "Entrar", "cta.register": "Registar",
    "cta.viewProducts": "Ver produtos", "cta.explore": "Explorar novidades",
    "cta.viewAll": "Ver todos", "cta.addToCart": "Adicionar ao carrinho",
    "cta.buyNow": "Comprar agora", "cta.discover": "Descobrir agora",
    "cta.viewProduct": "Ver produto", "cta.checkout": "Finalizar compra",
    "cta.continue": "Continuar a comprar",
    "hero.badge": "Entrega em Portugal 🇵🇹 e Angola 🇦🇴",
    "hero.title.a": "A tecnologia que procuras,", "hero.title.b": "num só lugar.",
    "hero.subtitle": "Descobre smartphones, computadores, acessórios e muito mais.",
    "hero.featured": "Destaque da semana",
    "home.categories.eyebrow": "Explorar", "home.categories.title": "Categorias",
    "home.featured.eyebrow": "Selecionados para ti", "home.featured.title": "Produtos em destaque",
    "home.bento.eyebrow": "Lançamento 2026",
    "home.bento.title": "Tecnologia de\nnova geração.",
    "home.bento.gaming": "Domina o jogo", "home.bento.audio": "Som que sentes",
    "trust.delivery": "Entrega rápida", "trust.deliveryText": "Portugal e Angola",
    "trust.secure": "Pagamentos seguros", "trust.secureText": "Visa · Mastercard",
    "trust.curated": "Produtos selecionados", "trust.curatedText": "Qualidade garantida",
    "trust.support": "Apoio ao cliente", "trust.supportText": "Sempre online",
    "trust.returns": "Devolução 30 dias", "trust.returnsText": "Sem stress",
    "trust.currency": "Multi-moeda", "trust.currencyText": "EUR · Kwanza (AOA)",
    "product.rating": "avaliações", "product.inStock": "Em stock", "product.outOfStock": "Esgotado",
    "product.lastUnits": "Últimas unidades", "product.color": "Cor", "product.size": "Modelo/Tamanho",
    "product.available": "disponíveis", "product.deliveryIn": "Entrega em",
    "product.days": "dias", "product.securePay": "Pagamento seguro",
    "products.title": "Produtos", "products.eyebrow": "Catálogo",
    "products.search": "Pesquisar produtos...", "products.searchBtn": "Procurar",
    "products.all": "Todos", "products.none": "Nenhum produto encontrado.",
    "cart.title": "Carrinho", "cart.empty": "O teu carrinho está vazio",
    "cart.emptyText": "Explora a nossa gama de tecnologia premium.",
    "cart.summary": "Resumo", "cart.subtotal": "Subtotal",
    "cart.taxesNote": "Portes e impostos calculados no checkout.",
    "checkout.title": "Finalizar compra", "checkout.contact": "Contacto e envio",
    "checkout.email": "Email", "checkout.fullName": "Nome completo",
    "checkout.address": "Morada", "checkout.line2": "Complemento",
    "checkout.city": "Cidade", "checkout.region": "Região/Estado",
    "checkout.postal": "Código postal", "checkout.country": "País",
    "checkout.phone": "Telefone", "checkout.shipping": "Método de envio",
    "checkout.standard": "Standard",
    "checkout.review": "Rever pagamento", "checkout.pay": "Pagamento",
    "checkout.orderCreated": "Encomenda", "checkout.orderCreatedSuffix": "criada. Confirma o pagamento.",
    "checkout.paypalTitle": "PayPal / Cartões",
    "checkout.paypalDesc": "Ao clicar, serás redirecionado para o PayPal (Visa, Mastercard, AmEx e métodos locais suportados).",
    "checkout.paypalBtn": "Pagar com PayPal",
    "checkout.demoNote": "Modo de demonstração — o admin deve configurar as chaves PayPal em `.env`.",
    "checkout.back": "Voltar", "checkout.promo": "Código promocional",
    "checkout.apply": "Aplicar", "checkout.discount": "Desconto",
    "checkout.shippingLabel": "Envio", "checkout.taxes": "Impostos", "checkout.total": "Total",
    "checkout.success": "Encomenda confirmada!", "checkout.orderNumber": "Número da encomenda:",
    "checkout.successText": "Enviamos um email de confirmação. Podes acompanhar o estado na tua conta.",
    "checkout.successContinue": "Continuar", "checkout.moreProducts": "Ver mais produtos",
    "auth.login": "Iniciar sessão", "auth.loginSub": "Entra na tua conta VOLTIX.",
    "auth.register": "Criar conta", "auth.registerSub": "Junta-te à VOLTIX.",
    "auth.password": "Password", "auth.name": "Nome", "auth.noAccount": "Não tens conta?",
    "auth.hasAccount": "Já tens conta?", "auth.registerLink": "Regista-te",
    "auth.loginLink": "Entra",
    "wishlist.title": "Favoritos", "wishlist.empty": "Ainda não tens produtos favoritos.",
    "wishlist.add": "Adicionar aos favoritos", "wishlist.remove": "Remover dos favoritos",
    "wishlist.added": "Adicionado aos favoritos", "wishlist.removed": "Removido dos favoritos",
    "footer.tagline": "Tecnologia ao teu alcance.",
    "footer.store": "Loja", "footer.help": "Ajuda", "footer.payments": "Pagamentos",
    "footer.rights": "Todos os direitos reservados.",
    "toast.addedCart": "adicionado ao carrinho",
  },
  en: {
    "nav.home": "Home", "nav.products": "Products", "nav.categories": "Categories",
    "nav.new": "New", "nav.promo": "Promotions", "nav.about": "About",
    "nav.contact": "Contact", "nav.wishlist": "Wishlist",
    "top.delivery": "Delivery to Portugal and Angola",
    "top.secure": "Secure payments with Stripe",
    "top.markets": "🇵🇹 Portugal · 🇦🇴 Angola",
    "cta.login": "Log in", "cta.register": "Sign up",
    "cta.viewProducts": "View products", "cta.explore": "Explore what's new",
    "cta.viewAll": "See all", "cta.addToCart": "Add to cart",
    "cta.buyNow": "Buy now", "cta.discover": "Discover now",
    "cta.viewProduct": "View product", "cta.checkout": "Checkout",
    "cta.continue": "Continue shopping",
    "hero.badge": "Delivery to Portugal 🇵🇹 and Angola 🇦🇴",
    "hero.title.a": "The technology you're looking for,", "hero.title.b": "all in one place.",
    "hero.subtitle": "Discover smartphones, laptops, accessories and more.",
    "hero.featured": "Weekly highlight",
    "home.categories.eyebrow": "Explore", "home.categories.title": "Categories",
    "home.featured.eyebrow": "Picked for you", "home.featured.title": "Featured products",
    "home.bento.eyebrow": "2026 launch",
    "home.bento.title": "Next-generation\ntechnology.",
    "home.bento.gaming": "Dominate the game", "home.bento.audio": "Sound you feel",
    "trust.delivery": "Fast delivery", "trust.deliveryText": "Portugal & Angola",
    "trust.secure": "Secure payments", "trust.secureText": "Visa · Mastercard",
    "trust.curated": "Curated products", "trust.curatedText": "Quality guaranteed",
    "trust.support": "Customer support", "trust.supportText": "Always online",
    "trust.returns": "30-day returns", "trust.returnsText": "Hassle-free",
    "trust.currency": "Multi-currency", "trust.currencyText": "EUR · Kwanza (AOA)",
    "product.rating": "reviews", "product.inStock": "In stock", "product.outOfStock": "Sold out",
    "product.lastUnits": "Last units", "product.color": "Color", "product.size": "Model/Size",
    "product.available": "available", "product.deliveryIn": "Delivery in",
    "product.days": "days", "product.securePay": "Secure payment",
    "products.title": "Products", "products.eyebrow": "Catalog",
    "products.search": "Search products...", "products.searchBtn": "Search",
    "products.all": "All", "products.none": "No products found.",
    "cart.title": "Cart", "cart.empty": "Your cart is empty",
    "cart.emptyText": "Explore our premium tech range.",
    "cart.summary": "Summary", "cart.subtotal": "Subtotal",
    "cart.taxesNote": "Shipping and taxes calculated at checkout.",
    "checkout.title": "Checkout", "checkout.contact": "Contact & shipping",
    "checkout.email": "Email", "checkout.fullName": "Full name",
    "checkout.address": "Address", "checkout.line2": "Line 2",
    "checkout.city": "City", "checkout.region": "State/Region",
    "checkout.postal": "Postal code", "checkout.country": "Country",
    "checkout.phone": "Phone", "checkout.shipping": "Shipping method",
    "checkout.standard": "Standard",
    "checkout.review": "Review payment", "checkout.pay": "Payment",
    "checkout.orderCreated": "Order", "checkout.orderCreatedSuffix": "created. Confirm payment.",
    "checkout.paypalTitle": "PayPal / Cards",
    "checkout.paypalDesc": "You'll be redirected to PayPal (Visa, Mastercard, AmEx and local methods supported).",
    "checkout.paypalBtn": "Pay with PayPal",
    "checkout.demoNote": "Demo mode — the admin must configure PayPal keys in `.env`.",
    "checkout.back": "Back", "checkout.promo": "Promo code",
    "checkout.apply": "Apply", "checkout.discount": "Discount",
    "checkout.shippingLabel": "Shipping", "checkout.taxes": "Taxes", "checkout.total": "Total",
    "checkout.success": "Order confirmed!", "checkout.orderNumber": "Order number:",
    "checkout.successText": "We've sent a confirmation email. Track status in your account.",
    "checkout.successContinue": "Continue", "checkout.moreProducts": "See more products",
    "auth.login": "Log in", "auth.loginSub": "Enter your VOLTIX account.",
    "auth.register": "Create account", "auth.registerSub": "Join VOLTIX.",
    "auth.password": "Password", "auth.name": "Name", "auth.noAccount": "No account?",
    "auth.hasAccount": "Already have an account?", "auth.registerLink": "Sign up",
    "auth.loginLink": "Log in",
    "wishlist.title": "Wishlist", "wishlist.empty": "You haven't saved any favorites yet.",
    "wishlist.add": "Add to wishlist", "wishlist.remove": "Remove from wishlist",
    "wishlist.added": "Added to wishlist", "wishlist.removed": "Removed from wishlist",
    "footer.tagline": "Technology within your reach.",
    "footer.store": "Store", "footer.help": "Help", "footer.payments": "Payments",
    "footer.rights": "All rights reserved.",
    "toast.addedCart": "added to cart",
  },
  fr: {
    "nav.home": "Accueil", "nav.products": "Produits", "nav.categories": "Catégories",
    "nav.new": "Nouveautés", "nav.promo": "Promotions", "nav.about": "À propos",
    "nav.contact": "Contact", "nav.wishlist": "Favoris",
    "top.delivery": "Livraison au Portugal et en Angola",
    "top.secure": "Paiements sécurisés avec Stripe",
    "top.markets": "🇵🇹 Portugal · 🇦🇴 Angola",
    "cta.login": "Connexion", "cta.register": "Créer un compte",
    "cta.viewProducts": "Voir les produits", "cta.explore": "Explorer les nouveautés",
    "cta.viewAll": "Tout voir", "cta.addToCart": "Ajouter au panier",
    "cta.buyNow": "Acheter", "cta.discover": "Découvrir",
    "cta.viewProduct": "Voir le produit", "cta.checkout": "Finaliser",
    "cta.continue": "Continuer les achats",
    "hero.badge": "Livraison Portugal 🇵🇹 & Angola 🇦🇴",
    "hero.title.a": "La technologie que tu cherches,", "hero.title.b": "en un seul endroit.",
    "hero.subtitle": "Découvre smartphones, ordinateurs, accessoires et plus encore.",
    "hero.featured": "Sélection de la semaine",
    "home.categories.eyebrow": "Explorer", "home.categories.title": "Catégories",
    "home.featured.eyebrow": "Sélectionnés pour toi", "home.featured.title": "Produits phares",
    "home.bento.eyebrow": "Lancement 2026",
    "home.bento.title": "Technologie de\nnouvelle génération.",
    "home.bento.gaming": "Domine le jeu", "home.bento.audio": "Le son qui vibre",
    "trust.delivery": "Livraison rapide", "trust.deliveryText": "Portugal et Angola",
    "trust.secure": "Paiements sécurisés", "trust.secureText": "Visa · Mastercard",
    "trust.curated": "Produits sélectionnés", "trust.curatedText": "Qualité garantie",
    "trust.support": "Service client", "trust.supportText": "Toujours dispo",
    "trust.returns": "Retour 30 jours", "trust.returnsText": "Sans souci",
    "trust.currency": "Multi-devises", "trust.currencyText": "EUR · Kwanza (AOA)",
    "product.rating": "avis", "product.inStock": "En stock", "product.outOfStock": "Épuisé",
    "product.lastUnits": "Derniers exemplaires", "product.color": "Couleur", "product.size": "Modèle/Taille",
    "product.available": "disponibles", "product.deliveryIn": "Livraison en",
    "product.days": "jours", "product.securePay": "Paiement sécurisé",
    "products.title": "Produits", "products.eyebrow": "Catalogue",
    "products.search": "Rechercher...", "products.searchBtn": "Rechercher",
    "products.all": "Tous", "products.none": "Aucun produit trouvé.",
    "cart.title": "Panier", "cart.empty": "Ton panier est vide",
    "cart.emptyText": "Explore notre gamme tech premium.",
    "cart.summary": "Résumé", "cart.subtotal": "Sous-total",
    "cart.taxesNote": "Frais et taxes calculés au paiement.",
    "checkout.title": "Finaliser", "checkout.contact": "Contact & livraison",
    "checkout.email": "Email", "checkout.fullName": "Nom complet",
    "checkout.address": "Adresse", "checkout.line2": "Complément",
    "checkout.city": "Ville", "checkout.region": "Région",
    "checkout.postal": "Code postal", "checkout.country": "Pays",
    "checkout.phone": "Téléphone", "checkout.shipping": "Mode de livraison",
    "checkout.standard": "Standard",
    "checkout.review": "Vérifier paiement", "checkout.pay": "Paiement",
    "checkout.orderCreated": "Commande", "checkout.orderCreatedSuffix": "créée. Confirme le paiement.",
    "checkout.paypalTitle": "PayPal / Cartes",
    "checkout.paypalDesc": "Redirection vers PayPal (Visa, Mastercard, AmEx et méthodes locales).",
    "checkout.paypalBtn": "Payer avec PayPal",
    "checkout.demoNote": "Mode démo — l'admin doit configurer les clés PayPal.",
    "checkout.back": "Retour", "checkout.promo": "Code promo",
    "checkout.apply": "Appliquer", "checkout.discount": "Remise",
    "checkout.shippingLabel": "Livraison", "checkout.taxes": "Taxes", "checkout.total": "Total",
    "checkout.success": "Commande confirmée !", "checkout.orderNumber": "Numéro de commande :",
    "checkout.successText": "Un email de confirmation a été envoyé.",
    "checkout.successContinue": "Continuer", "checkout.moreProducts": "Voir plus de produits",
    "auth.login": "Connexion", "auth.loginSub": "Entre dans ton compte VOLTIX.",
    "auth.register": "Créer un compte", "auth.registerSub": "Rejoins VOLTIX.",
    "auth.password": "Mot de passe", "auth.name": "Nom", "auth.noAccount": "Pas de compte ?",
    "auth.hasAccount": "Déjà un compte ?", "auth.registerLink": "S'inscrire",
    "auth.loginLink": "Se connecter",
    "wishlist.title": "Favoris", "wishlist.empty": "Aucun favori pour le moment.",
    "wishlist.add": "Ajouter aux favoris", "wishlist.remove": "Retirer des favoris",
    "wishlist.added": "Ajouté aux favoris", "wishlist.removed": "Retiré des favoris",
    "footer.tagline": "La technologie à portée de main.",
    "footer.store": "Boutique", "footer.help": "Aide", "footer.payments": "Paiements",
    "footer.rights": "Tous droits réservés.",
    "toast.addedCart": "ajouté au panier",
  },
  ar: {
    "nav.home": "الرئيسية", "nav.products": "المنتجات", "nav.categories": "الفئات",
    "nav.new": "جديد", "nav.promo": "العروض", "nav.about": "من نحن",
    "nav.contact": "اتصل بنا", "nav.wishlist": "المفضلة",
    "top.delivery": "التوصيل إلى البرتغال وأنغولا",
    "top.secure": "مدفوعات آمنة عبر Stripe",
    "top.markets": "🇵🇹 البرتغال · 🇦🇴 أنغولا",
    "cta.login": "تسجيل الدخول", "cta.register": "إنشاء حساب",
    "cta.viewProducts": "عرض المنتجات", "cta.explore": "اكتشف الجديد",
    "cta.viewAll": "عرض الكل", "cta.addToCart": "أضف إلى السلة",
    "cta.buyNow": "اشتر الآن", "cta.discover": "اكتشف الآن",
    "cta.viewProduct": "عرض المنتج", "cta.checkout": "إتمام الشراء",
    "cta.continue": "مواصلة التسوق",
    "hero.badge": "التوصيل إلى البرتغال 🇵🇹 وأنغولا 🇦🇴",
    "hero.title.a": "التكنولوجيا التي تبحث عنها،", "hero.title.b": "في مكان واحد.",
    "hero.subtitle": "اكتشف الهواتف والحواسيب والملحقات والمزيد.",
    "hero.featured": "منتج الأسبوع",
    "home.categories.eyebrow": "استكشف", "home.categories.title": "الفئات",
    "home.featured.eyebrow": "مختار لك", "home.featured.title": "المنتجات المميزة",
    "home.bento.eyebrow": "إطلاق 2026",
    "home.bento.title": "تكنولوجيا الجيل\nالجديد.",
    "home.bento.gaming": "سيطر على اللعبة", "home.bento.audio": "صوت تشعر به",
    "trust.delivery": "توصيل سريع", "trust.deliveryText": "البرتغال وأنغولا",
    "trust.secure": "مدفوعات آمنة", "trust.secureText": "Visa · Mastercard",
    "trust.curated": "منتجات مختارة", "trust.curatedText": "جودة مضمونة",
    "trust.support": "دعم العملاء", "trust.supportText": "دائماً متاح",
    "trust.returns": "إرجاع خلال 30 يومًا", "trust.returnsText": "دون عناء",
    "trust.currency": "عملات متعددة", "trust.currencyText": "EUR · كوانزا (AOA)",
    "product.rating": "تقييمات", "product.inStock": "متوفر", "product.outOfStock": "نفذ",
    "product.lastUnits": "آخر القطع", "product.color": "اللون", "product.size": "الحجم/الطراز",
    "product.available": "متاح", "product.deliveryIn": "التوصيل خلال",
    "product.days": "أيام", "product.securePay": "دفع آمن",
    "products.title": "المنتجات", "products.eyebrow": "الكتالوج",
    "products.search": "ابحث عن منتجات...", "products.searchBtn": "بحث",
    "products.all": "الكل", "products.none": "لا توجد منتجات.",
    "cart.title": "السلة", "cart.empty": "سلتك فارغة",
    "cart.emptyText": "اكتشف مجموعتنا الرائدة.",
    "cart.summary": "الملخص", "cart.subtotal": "المجموع الفرعي",
    "cart.taxesNote": "يتم حساب الشحن والضرائب عند الدفع.",
    "checkout.title": "إتمام الشراء", "checkout.contact": "بيانات التوصيل",
    "checkout.email": "البريد", "checkout.fullName": "الاسم الكامل",
    "checkout.address": "العنوان", "checkout.line2": "تكملة",
    "checkout.city": "المدينة", "checkout.region": "المنطقة",
    "checkout.postal": "الرمز البريدي", "checkout.country": "الدولة",
    "checkout.phone": "الهاتف", "checkout.shipping": "طريقة الشحن",
    "checkout.standard": "عادي",
    "checkout.review": "مراجعة الدفع", "checkout.pay": "الدفع",
    "checkout.orderCreated": "الطلب", "checkout.orderCreatedSuffix": "تم إنشاؤه. أكد الدفع.",
    "checkout.paypalTitle": "PayPal / بطاقات",
    "checkout.paypalDesc": "سيتم تحويلك إلى PayPal.",
    "checkout.paypalBtn": "ادفع عبر PayPal",
    "checkout.demoNote": "وضع تجريبي — يجب تكوين مفاتيح PayPal.",
    "checkout.back": "رجوع", "checkout.promo": "كود خصم",
    "checkout.apply": "تطبيق", "checkout.discount": "خصم",
    "checkout.shippingLabel": "الشحن", "checkout.taxes": "الضرائب", "checkout.total": "المجموع",
    "checkout.success": "تم تأكيد الطلب!", "checkout.orderNumber": "رقم الطلب:",
    "checkout.successText": "تم إرسال بريد التأكيد.",
    "checkout.successContinue": "متابعة", "checkout.moreProducts": "المزيد من المنتجات",
    "auth.login": "تسجيل الدخول", "auth.loginSub": "ادخل إلى حسابك.",
    "auth.register": "إنشاء حساب", "auth.registerSub": "انضم إلى VOLTIX.",
    "auth.password": "كلمة المرور", "auth.name": "الاسم", "auth.noAccount": "ليس لديك حساب؟",
    "auth.hasAccount": "لديك حساب؟", "auth.registerLink": "سجل",
    "auth.loginLink": "دخول",
    "wishlist.title": "المفضلة", "wishlist.empty": "لا توجد منتجات في المفضلة.",
    "wishlist.add": "أضف للمفضلة", "wishlist.remove": "إزالة من المفضلة",
    "wishlist.added": "تمت الإضافة للمفضلة", "wishlist.removed": "تمت الإزالة من المفضلة",
    "footer.tagline": "التكنولوجيا في متناولك.",
    "footer.store": "المتجر", "footer.help": "المساعدة", "footer.payments": "المدفوعات",
    "footer.rights": "جميع الحقوق محفوظة.",
    "toast.addedCart": "تمت الإضافة للسلة",
  },
};

export function translate(locale, key) {
  return dict[locale]?.[key] ?? dict.pt[key] ?? key;
}
